<template>
  <div class="details">
    <v-card ref="details">
      <v-toolbar fixed flat color="white" style="border-radius:0px">
        <v-btn icon dark @click="close()">
          <v-icon color="black">mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title style="text-transform:capitalize;font-weight:bold;">{{data.name}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text
        class="plans-content"
        style="height:auto;max-height: auto;padding:10px; margin:0px auto;"
      >
        <div style="margin-bottom:20px">
          <h4 style="color:#000">Key Features & highlights</h4>
          <ul class="plan-card-features">
            <li
              class="plan-card-feature"
              v-for="(feature, index) in data.fullFeatures"
              :key="data.id+'feature'+index"
              style="font-size:12px;"
            >{{ feature }}</li>
          </ul>
        </div>
        <div style="margin-bottom:25px">
          <h4 style="color:#000">Product description and technical details</h4>
          <v-simple-table dense v-if="Array.isArray(data.specs) && data.specs.length >= 1">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="font-size:10px;padding-left:5px;padding-right:0px">
                    <span style="display:block;width:165px"></span>
                  </th>
                  <th class="text-left" style="font-size:12px;padding-left:5px;padding-right:0px">
                    <span style="display:block;width:165px"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, $index) in data.specs" :key="'detailsRow' + $index">
                  <td
                    style="font-size:12px;padding-left:5px;padding-right:0px"
                  >{{ item.specification }}</td>
                  <td
                    style="font-size:12px;padding-left:5px;padding-right:0px;font-weight:600"
                  >{{ item.detail }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div v-if="data.comparison">
          <h4 style="color:#000">Product description and technical details</h4>
          <v-simple-table
            dense
            v-if="Array.isArray(data.comparison) && data.comparison.length >= 1"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="font-size:14px;padding-left:5px;padding-right:0px">
                    <span style="display:block;width:165px">Feature</span>
                  </th>
                  <th
                    class="text-left"
                    style="font-size:14px;padding-left:5px;padding-right:0px;text-align:center"
                  >
                    <span style="display:block;width:60px">Basic</span>
                  </th>
                  <th
                    class="text-left"
                    style="font-size:14px;padding-left:5px;padding-right:0px;text-align:center"
                  >
                    <span style="display:block;width:60px">Pro</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, $index) in data.comparison" :key="'detailsRow' + $index">
                  <td
                    style="font-size:12px;padding-left:5px;padding-right:0px;border-right:1px solid #eee; text-align:left"
                  >{{ item.feature }}</td>
                  <td
                    style="font-size:12px;padding-left:5px;padding-right:0px;font-weight:600;border-right:1px solid #eee; text-align:center"
                  >{{ item.basic }}</td>
                  <td
                    style="font-size:12px;padding-left:5px;padding-right:0px;font-weight:600;text-align:center"
                  >{{ item.pro }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Details",
  components: {},
  props: ["data"],
  data: function() {
    return {};
  },
  methods: {
    close: function() {
      this.$emit("close");
    }
  }
};
</script>